export default {"src":"/_next/static/image/public/images/social_tiktok_blue.3cc7852ee968b507e83fa80385911445.svg","height":14,"width":14};